define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FacilityStatusDomain = void 0;
    class FacilityStatusDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: FacilityStatusDomain.Proposed, value: "Proposed" },
                    { key: FacilityStatusDomain.Confirmed, value: "Confirmed" },
                    { key: FacilityStatusDomain.Archived, value: "Archived" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[FacilityStatusDomain.Proposed] = 0;
                this.KeyIndex[FacilityStatusDomain.Confirmed] = 1;
                this.KeyIndex[FacilityStatusDomain.Archived] = 2;
                this.ValueIndex = {};
                this.ValueIndex["Proposed"] = 0;
                this.ValueIndex["Confirmed"] = 1;
                this.ValueIndex["Archived"] = 2;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.FacilityStatusDomain = FacilityStatusDomain;
    Object.defineProperty(FacilityStatusDomain, "Proposed", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 0
    });
    Object.defineProperty(FacilityStatusDomain, "Confirmed", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 1
    });
    Object.defineProperty(FacilityStatusDomain, "Archived", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(FacilityStatusDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
